"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Skeleton = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '100%' : _b, height = _a.height;
    var styles = { width: width };
    if (height) {
        styles.height = height;
    }
    return react_1.default.createElement("span", { style: styles, className: "cm-skeleton" });
};
exports.default = Skeleton;
